import { cn } from "../utils/cn";
import ColoredBar from "./coloredBar";
import Container from "./container";
import FormularioRD from "../rdstation/formularioRD";
import { useModal } from "../contexts/ModalContext";

export default function BannerDevelopment({
    title,
    description,
    bottomText,
    bottomTextMobile,
    backgroundUrl = "../assets/banner-development.png",
    imageMobile = "banner-development-mobile.png",
    variant = "primary",
    brand,
}) {
    const { openModal } = useModal();
    return (
        <div className="relative">
            <div
                className={cn(
                    `w-full min-h-[calc(100vw+200px)] lg:min-h-auto lg:h-screen bg-[url('../assets/${imageMobile}')] lg:bg-[url(${backgroundUrl})] bg-no-repeat bg-cover bg-center text-white relative flex flex-col`
                )}
            >
                {/* Main content - absolute positioning for true center */}
                <div className="absolute inset-0 flex flex-col justify-center item-center z-20 mb-30 md:mb-0">
                    <Container className="space-y-8">
                        <div className="space-y-6 lg:space-y-12 text-left lg:text-center w-full">
                            <div className="flex items-center ml-2 lg:ml-0 justify-left lg:justify-center gap-2 mx-auto leading-[1.2]">
                                <img
                                    className="hidden lg:block"
                                    src={
                                        brand === "nex2ai"
                                            ? "../assets/icone-projectiva-nex2ai.png"
                                            : brand === "omnicore"
                                            ? "../assets/icone-projectiva-omnicore.png"
                                            : "../assets/icone-projectiva-behub.png"
                                    }
                                    alt="Logo"
                                />
                                <h1 className="ml-1 text-[42px] md:text-6xl uppercase font-titillium-web-light">
                                    {title}
                                </h1>
                            </div>
                            <p className="md:text-xl text-center lg:max-w-[806px] mx-auto font-inter-regular">
                                {description}
                            </p>
                        </div>
                    </Container>
                </div>

                {/* Footer - fixed at bottom */}
                <Container className="mt-auto flex flex-col md:flex-row items-center gap-6 justify-center relative z-20 mb-10">
                    <div className="lg:hidden flex items-center justify-center gap-2">
                        <img
                            className="block h-7 object-fill"
                            src={
                                brand === "nex2ai"
                                    ? "../assets/icone-projectiva-nex2ai.png"
                                    : brand === "omnicore"
                                    ? "../assets/icone-projectiva-omnicore.png"
                                    : "../assets/icone-projectiva-behub.png"
                            }
                            alt="Logo"
                        />
                        <p className="block text-sm font-inter-light">
                            {brand === "nex2ai" ? (
                                <>
                                    <strong className="font-inter-bold">nex</strong>
                                    2ai
                                </>
                            ) : brand === "omnicore" ? (
                                <>
                                    <strong className="font-inter-bold">omni</strong>
                                    core
                                </>
                            ) : (
                                <>
                                    <strong className="font-inter-bold">be.</strong>
                                    hub
                                </>
                            )}
                        </p>
                    </div>
                    <div className="block tracking-[3px] text-xs md:text-base font-inter-regular">
                        <span className="md:hidden">
                            {/* For mobile, show simplified text */}
                            {bottomTextMobile || (typeof bottomText === 'string' ? bottomText.split('|')[0].trim() : 'VERTICAL')}
                        </span>
                        <span className="hidden md:inline">
                            {/* For desktop, show the full text */}
                            {bottomText}
                        </span>
                    </div>

                    <button
                        onClick={() => openModal(<FormularioRD />)}
                        className={cn(
                            "cursor-pointer text-nowrap text-white font-medium py-3.5 px-10 lg:py-1 lg:px-8 rounded-[5px] text-xs md:text-lg shadow-md inline-block hover:scale-105 transition-all duration-300 tracking-wider",
                            brand === "omnicore" &&
                                "bg-gradient-to-r from-[#4B3BDB] via-[#4B3BDB] to-[#A002CB]",
                            brand === "behub" &&
                                "bg-gradient-to-r from-[#4B3BDB] to-[#A002CB]",
                            brand === "nex2ai" &&
                                "bg-gradient-to-r from-[#FC0021] to-[#910CCE]"
                        )}
                    >
                        Quero me conectar
                    </button>
                </Container>
            </div>
            <img
                src="../assets/black-shadow.png"
                alt=""
                className="absolute lg:block bottom-0 w-full left-0 h-[60vh] z-10"
            />
            <div className="relative z-40">
                <ColoredBar hoveredBrand={brand} brands={[{ id: brand }]} className="mt-0" />
            </div>
        </div>
    );
}
